// extracted by mini-css-extract-plugin
module.exports = {"list":"_2XOOc","listOverlay":"_2vjqZ","listItem":"_1J6aa"};